<template>
  <div>
    <v-list three-line subheader>
      <v-list-item>
        <v-list-item-content>
          <v-card max-width="600px" class="pa-5 ma-1">
            <v-form v-model="formValid" :disabled="creating" @submit.prevent="addAssociation">
              <v-text-field full-width placeholder="Association or group description" hide-details
                prepend-inner-icon="mdi-account-supervisor-circle-outline" filled single-line :rules="rules.required"
                v-model="description"></v-text-field>
              <v-text-field full-width class="mt-2" placeholder="Shortcode" hide-details
                prepend-inner-icon="mdi-octagram-outline" filled single-line v-mask="'AAAA'" :rules="rules.shortcode"
                v-model="code">
              </v-text-field>
              <div v-if="association_id" class="mt-3">
                <v-btn :loading="updating" :disabled="!formValid || updating" @click="updateAssociation" color="green"
                  type="submit" outlined large>
                  Update association
                </v-btn>
                <v-btn :disabled="updating" @click="cancelAssociationUpdate" class="ml-2" outlined large>
                  Cancel
                </v-btn>
              </div>
              <v-btn v-else :loading="creating" :disabled="!formValid || creating" type="submit" class="mt-3"
                color="green" outlined large>
                Save association
              </v-btn>
            </v-form>
          </v-card>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-container class="ml-1">
      <h3 class="mx-1 mt-2 mb-3">
        Registered associations & groups
        <span class="grey--text">({{ associations.length }})</span>
      </h3>

      <v-chip label v-for="association in associations" :key="association.id" class="ma-1" color="brown"
        text-color="white">
        {{ association.description }}
        <div v-if="!association_id || association.deletable" class="ml-2 pl-1" style="border-left: 1px solid #8a624a">
          <v-btn v-if="!association_id" title="Edit association" small icon color="primary" class="ml-1"
            @click="editAssociation(association)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn title="Delete association" v-if="association.deletable" icon small color="white"
            @click="removeAssociation(association.id)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-chip>
    </v-container>
  </div>
</template>

<script>
import { required, shortcode } from "../../tools/rules";
export default {
  data: () => ({
    formValid: false,
    description: null,
    code: null,
    creating: false,
    updating: false,
    association_id: null,
    associations: [],
    rules: {
      required,
      shortcode,
    },
  }),

  watch: {
    code(val) {
      this.code = val.toUpperCase();
    },
  },

  methods: {
    editAssociation(association) {
      this.association_id = association.id;
      this.description = association.description;
      this.code = association.code;
    },
    cancelAssociationUpdate() {
      this.association_id = null;
      this.description = null;
      this.code = null;
    },
    addAssociation() {
      this.creating = true;

      this.$axios({
        url: "/associations",
        method: "POST",
        data: {
          description: this.description,
          code: this.code,
        },
      })
        .then(() => {
          this.description = null;
          this.code = null;
          this.fetchAssociations();
          this.$bus.$emit("associations.updated");
        })
        .catch((error) => {
          const { status } = error.response;

          if (status == 409) {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Code already exist. Try again.",
            });
          } else {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Something went wrong.",
            });
          }
        })
        .finally(() => {
          this.creating = false;
        });
    },
    updateAssociation() {
      this.updating = true;

      this.$axios({
        url: `/associations/${this.association_id}`,
        method: "PUT",
        data: {
          description: this.description,
          code: this.code,
        },
      })
        .then(() => {
          this.cancelAssociationUpdate();
          this.fetchAssociations();
          this.$bus.$emit("associations.updated");
        })
        .catch((error) => {
          const { status } = error.response;

          if (status == 409) {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Code already exist. Try again.",
            });
          } else {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Something went wrong.",
            });
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },
    removeAssociation(association) {
      if (confirm("Do you really want to delete this association?")) {
        this.$axios({
          url: `associations/${association}`,
          method: "DELETE",
        })
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Deleted",
            });
            this.$bus.$emit("associations.updated");
            this.fetchAssociations();
          })
          .catch((error) => {
            console.error(error);
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Delete failed",
            });
          });
      }
    },
    fetchAssociations() {
      this.$axios({
        url: "/associations",
        method: "GET",
      }).then(({ data: associations }) => {
        this.associations = associations;
      });
    },
  },

  mounted() {
    this.fetchAssociations();
  },
};
</script>
